import React, { useState } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { submitBanquetEnquiry } from "../../services/banquetEnquiryService.js";

const inputClassName =
  "min-h-[46px] w-full rounded-2xl border border-slate-200 bg-white px-3.5 py-2.5 text-sm font-medium text-slate-800 shadow-sm outline-none transition placeholder:text-slate-400 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-100";

const normalizePhone = (value) => value.replace(/\D/g, "");

export default function BanquetEnquiryForm({ banquet }) {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [preferredDate, setPreferredDate] = useState("");
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();

    const trimmedName = name.trim();
    const digitsPhone = normalizePhone(phone);

    if (!trimmedName) {
      setError("Please enter your name.");
      return;
    }

    if (digitsPhone.length < 10 || digitsPhone.length > 12) {
      setError("Please enter a valid phone number.");
      return;
    }

    setError("");
    setStatus("submitting");

    try {
      await submitBanquetEnquiry({
        banquetId: banquet?.id,
        banquetName: banquet?.name,
        customerName: trimmedName,
        customerPhone: digitsPhone,
        preferredDate: preferredDate || null,
      });
      setStatus("success");
      setName("");
      setPhone("");
      setPreferredDate("");
    } catch (submitError) {
      setStatus("error");
      setError("Something went wrong. Please try WhatsApp or Call instead.");
    }
  };

  if (status === "success") {
    return (
      <div className="mt-4 flex items-start gap-3 rounded-2xl border border-emerald-200 bg-emerald-50 p-4">
        <FaCheckCircle className="mt-0.5 shrink-0 text-emerald-600" />
        <div>
          <p className="text-sm font-bold text-emerald-900">Request received!</p>
          <p className="mt-1 text-sm text-emerald-800">Our team will call you back shortly with pricing and availability.</p>
        </div>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="mt-4 rounded-2xl border border-slate-200 bg-slate-50 p-4">
      <p className="text-sm font-bold text-slate-900">Prefer not to WhatsApp?</p>
      <p className="mt-1 text-xs text-slate-600">Leave your number and our team will call you back.</p>
      <div className="mt-3 grid gap-2">
        <input
          className={inputClassName}
          type="text"
          value={name}
          onChange={(event) => setName(event.target.value)}
          placeholder="Your name"
        />
        <input
          className={inputClassName}
          type="tel"
          inputMode="numeric"
          value={phone}
          onChange={(event) => setPhone(event.target.value)}
          placeholder="Phone number"
        />
        <input
          className={inputClassName}
          type="date"
          value={preferredDate}
          min={new Date().toISOString().split("T")[0]}
          onChange={(event) => setPreferredDate(event.target.value)}
        />
        {error ? <p className="text-xs font-semibold text-rose-600">{error}</p> : null}
        <button
          type="submit"
          disabled={status === "submitting"}
          className="inline-flex min-h-[46px] w-full items-center justify-center rounded-2xl bg-slate-950 px-4 py-3 text-sm font-bold text-white transition disabled:opacity-60"
        >
          {status === "submitting" ? "Submitting..." : "Request Callback"}
        </button>
      </div>
    </form>
  );
}
